export default __webpack_public_path__ + "static/media/predsjednik_rs.323e8eec.png";